// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { GalleryCarouselCardFragmentDoc } from './carousel/card/GalleryCarouselCard.fragment.generated';
import { CmsImageSizesFragmentDoc } from '../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../imageSize.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../index.generated';
export const ComponentGalleryCarouselFragmentDoc = `
    fragment componentGalleryCarousel on ComponentGalleryCarousel {
  __typename
  items {
    ...galleryCarouselCard
  }
}
    `;